/** @format */

export const tokens = {
  common: {
    languageChanged: 'common.languageChanged'
  },
  nav: {
    academy: 'nav.academy',
    account: 'nav.account',
    analytics: 'nav.analytics',
    auth: 'nav.auth',
    blog: 'nav.blog',
    browse: 'nav.browse',
    calendar: 'nav.calendar',
    chat: 'nav.chat',
    checkout: 'nav.checkout',
    concepts: 'nav.concepts',
    contact: 'nav.contact',
    course: 'nav.course',
    create: 'nav.create',
    crypto: 'nav.crypto',
    customers: 'nav.customers',
    dashboard: 'nav.dashboard',
    details: 'nav.details',
    ecommerce: 'nav.ecommerce',
    edit: 'nav.edit',
    error: 'nav.error',
    feed: 'nav.feed',
    fileManager: 'nav.fileManager',
    files: 'nav.files',
    finance: 'nav.finance',
    fleet: 'nav.fleet',
    forgotPassword: 'nav.forgotPassword',
    invoiceList: 'nav.invoices',
    jobList: 'nav.jobList',
    kanban: 'nav.kanban',
    list: 'nav.list',
    login: 'nav.login',
    logistics: 'nav.logistics',
    mail: 'nav.mail',
    management: 'nav.management',
    managementOverview: 'nav.managementOverview',
    managementAnalytic: 'nav.managementAnalytic',
    managementSchedule: 'nav.managementSchedule',
    managementCar: 'nav.managementCar',
    managementDashboard: 'nav.managementDashboard',
    managementControl: 'nav.managementControl',
    managementEvent: 'nav.managementEvent',
    managementDiagnostic: 'nav.managementDiagnostic',
    managementReport: 'nav.managementReport',
    managementAlarm: 'nav.managementAlarm',

    booking: 'nav.booking',
    configuration: 'nav.configuration',
    configurationCostBasic: 'nav.configuration.cost.basic',
    configurationCostOperating: 'nav.configuration.cost.operating',
    configurationCarBrand: 'nav.configuration.car.brand',
    configurationCarModel: 'nav.configuration.car.model',
    configurationCarFeature: 'nav.configuration.car.feature',
    configurationCarSpecification: 'nav.configuration.car.specification',

    administrator: 'nav.administrator',
    managementCustomer: 'nav.managementCustomer',
    managementUser: 'nav.managementUser',
    orderList: 'nav.orders',
    overview: 'nav.overview',
    pages: 'nav.pages',
    postCreate: 'nav.postCreate',
    postDetails: 'nav.postDetails',
    postList: 'nav.postList',
    pricing: 'nav.pricing',
    productList: 'nav.products',
    profile: 'nav.profile',
    register: 'nav.register',
    resetPassword: 'nav.resetPassword',
    socialMedia: 'nav.socialMedia',
    verifyCode: 'nav.verifyCode'
  },
  message: {
    validate: {
      isExist: 'message.validate.isExist'
    },
    confirmDelete: 'message.confirmDelete',
    confirmChangeActive: 'message.confirmChangeActive',
    createFailed: 'message.createFailed',
    updateFailed: 'message.updateFailed'
  }
};
